export enum UPLOAD_STATUS_ENUM {
  progress = 'progress',
  completed = 'completed',
  abort = 'abort',
  error = 'error',
}
